import axios from 'axios';
import normalizaMensagemApi from './normalizaMensagemApi';
import Vue from 'vue';
import router from '../routes';

const montaTokenRecaptcha = async (recaptchaSiteKey, action="index") => {
    try {
        return await window.grecaptcha.enterprise.execute(
            recaptchaSiteKey,
            { action }
        );
    } catch (error) {
        const message = normalizaMensagemApi(error);
        console.log('Erro ao gerar token do reCAPTCHA: ', message);
        return null;
    }
};

/**
 * Adiciona interceptador no request antes de cada chamada da api para configuração do token
 * 
 * @param {string} baseURL o apiUrl configurada no env
 * @param {Vuex.Store} store instancia da store configurada no keycloack
 * @returns {AxiosInstance}
 */
export default function montaInstanciaAxios(baseURL, store) {
    const instancia = axios.create({
        baseURL: baseURL,
    })
    instancia.interceptors.request.use(async (config) => {
        // Se o token não estiver no getters da store, ignora pois não tem sessão iniciada
        if (!store.getters.tokenParsed?.exp) {
            let action = router?.currentRoute?.path || null;
            action = action && action !== '/' ? action
                        .replaceAll('/', '_')
                        .replaceAll('-', '_')
                        .replaceAll(/([0-9]+)/g, '') :
                        'index';
            const recaptchaSiteKey = Vue.prototype.$env?.recaptchaSiteKey;
            const recaptchaToken = await montaTokenRecaptcha(recaptchaSiteKey, action);
            if (recaptchaToken) {
                config.headers['recaptcha-token'] = recaptchaToken;
                config.headers['recaptcha-site-key'] = recaptchaSiteKey;
                config.headers['recaptcha-action'] = action;
            }
            return config;
        }
        try {
            const agora = Date.now();
            const inicioValidadeToken = store.getters.tokenParsed.iat * 1000; // iat em milisegundos
            const fimValidadeToken = store.getters.tokenParsed.exp * 1000; // exp em milisegundos
            // Remove 10% do tempo de expiração
            const tempoTotal = fimValidadeToken - inicioValidadeToken;
            const tempoRestante = fimValidadeToken - agora;
            const estaPertoDeExpirar = tempoRestante < (tempoTotal * 0.1); // 10%
            // Verifica se o token está expirado e precisa gerar um novo no keycloak
            const tokenEstaExpirado = !fimValidadeToken || fimValidadeToken < agora || estaPertoDeExpirar;
            // Se o token estiver expirado ou próximo do tempo restante, atualiza o token
            if (tokenEstaExpirado) {
                await store.dispatch("REFRESH_TOKEN");
            }
            const token = store.getters.token;
            config.headers.Authorization = `Bearer ${token}`;
        } catch (error) {
            console.log('Erro ao atualizar o token: ', error);
        }
        return config;
    });
    instancia.interceptors.response.use((res) => res, (error) => {
        if (
            error.message === 'Network Error' ||
            error.response && error.response.status === 503
        ) {
            return Promise.reject(
                new Error(
                    `Estamos com uma instabilidade momentânea nos serviços. ` +
                    `Nossa equipe já está cuidando disso. Por favor, tente novamente em breve.`
                )
            );
        }
        return Promise.reject(error);
    });
    return instancia;
}